import React from 'react';
import { MyContext } from '../../../context';
import "./../../ReportView/ReportDetailContainer/ReportDetailContainer.scss"
import { DetailsList, DetailsListLayoutMode, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Stack, Text } from 'office-ui-fabric-react/lib';
import { Depths } from '@uifabric/fluent-theme/lib/fluent/FluentDepths';
import { Fabric } from 'office-ui-fabric-react/lib/';



export default class CaseManagementContainer extends React.Component {

    static contextType = MyContext;

    constructor(props) {
        super(props);

        let labelColumn = "";
        switch (this.props.data.kpi) {
            case "OverallComplianceRate":
                labelColumn = <MyContext.Consumer>{(context) => (<> {context.getTranslation("compliance", "compliance")}</>)}</MyContext.Consumer>
                break;
            case "OverallEscalationRate":
                labelColumn = <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "escalated")}</>)}</MyContext.Consumer>
                break;
            case "OverallResolutionTime":
                labelColumn = <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "resolution")}</>)}</MyContext.Consumer>
                break;
        }

        const columns = [
            {
                key: 'caseName',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("compliance", "name")}</>)}</MyContext.Consumer>,
                fieldName: 'caseName',
                isResizable: true,
                onColumnClick: this.onColumnClick
            },
            {
                key: 'ownerName',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationSafe", "owner")}</>)}</MyContext.Consumer>,
                fieldName: 'ownerName',
                isResizable: true,
                onColumnClick: this.onColumnClick
            },
            {
                key: 'caseStatus',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationSafe", "status")}</>)}</MyContext.Consumer>,
                fieldName: 'caseStatus',
                isResizable: true,
                onColumnClick: this.onColumnClick,
                onRender: (item) => {
                    return <MyContext.Consumer>{(context) => (
                        <span>{context.getTranslation("compliance", item.caseStatus.toLowerCase())}</span>
                    )}</MyContext.Consumer>;
                }
            },
            {
                key: 'reviewersName',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "reviewers")}</>)}</MyContext.Consumer>,
                fieldName: 'reviewersName',
                isResizable: true,
                minWidth: 200,
                onRender: (item) => {
                    return <span>{item.reviewersName.join(", ")}</span>;
                }
            },
            {
                key: 'creationDate',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("compliance", "creationDate")}</>)}</MyContext.Consumer>,
                fieldName: 'creationDate',
                minWidth: 150,
                onRender: (item) => {
                    const data = new Date(item.creationDate);
                    return <span>{data.toLocaleString()}</span>;
                }
            },
            {
                key: 'statusChangedDate',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "statusChangedDate")}</>)}</MyContext.Consumer>,
                fieldName: 'statusChangedDate',
                minWidth: 150,
                onRender: (item) => {
                    const data = new Date(item.statusChangedDate);
                    return <span>{data.toLocaleString()}</span>;
                }
            },
            {
                key: 'statusChangedUserName',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "statusChangedUserName")}</>)}</MyContext.Consumer>,
                fieldName: 'statusChangedUserName',
                onColumnClick: this.onColumnClick,
                minWidth: 150,
            },

            {
                key: 'result',
                name: labelColumn,
                fieldName: 'result',
                onColumnClick: this.onColumnClick,
            },

        ];

        if (this.props.data.kpi === "OverallResolutionTime") {
            columns.push({

                key: 'additionalInfo',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "additionalInfo")}</>)}</MyContext.Consumer>,
                fieldName: 'additionalInfo',
                onRender: (item) => {
                    return <span>{item.additionalInfo + " days"}</span>;
                }

            })
        }


        this.state = {
            items: this.props.data.caseInfos,
            columns: columns,
        };

    }


    onColumnClick = (ev, column) => {
        const { columns, items } = this.state;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
                this.setState({
                    announcedMessage: `${currColumn.name} is sorted ${currColumn.isSortedDescending ? 'descending' : 'ascending'
                        }`,
                });
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        const newItems = this.copyAndSort(items, currColumn.fieldName, currColumn.isSortedDescending);
        this.setState({
            columns: newColumns,
            items: newItems,
        });
    };

    copyAndSort(items, columnKey, isSortedDescending) {
        const key = columnKey
        return items.slice(0).sort((a, b) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
    }

    render() {
        const { columns, items } = this.state;

        return (<MyContext.Consumer>
            {(context) => (
                <Fabric>

                    <header className="report-panel-header ms-Grid-row" style={{ boxShadow: Depths.depth8 }}>


                        <Stack horizontal>
                            <Text style={{ padding: "5px" }} >{this.context.getTranslation("dashboard", this.props.data.kpi)}</Text>

                            <Text style={{ padding: "5px" }} >{this.props.data.title}</Text>

                        </Stack>
                    </header>
                    <div className="report-details-wrapper">


                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">

                                <DetailsList
                                    items={items}
                                    columns={columns}
                                    selectionMode={SelectionMode.none}
                                    setKey="set"
                                    layoutMode={DetailsListLayoutMode.fixedColumns}
                                    isHeaderVisible={true}
                                    selectionPreservedOnEmptyClick={true}
                                />

                            </div>
                        </div>
                    </div>
                </Fabric>
            )
            }
        </MyContext.Consumer>);

    }


}

